const WIX_MEDIA_BASE_URL = "https://static.wixstatic.com/";
const WIX_VIDEO_BASE_URL = "https://video.wixstatic.com/";
const getWixFilename = (url) => url.replace(WIX_MEDIA_BASE_URL, "");
const isAbsoluteUrl = (url) => url.startsWith("http://") || url.startsWith("https://");
const getAbsoluteUrl = (url, type) => {
  if (isAbsoluteUrl(url)) {
    return url;
  }
  let baseUrl, baseFolder;
  if (type === "image") {
    baseUrl = WIX_MEDIA_BASE_URL;
    baseFolder = "media/";
  } else {
    baseUrl = WIX_VIDEO_BASE_URL;
    baseFolder = "video/";
  }
  const pathWithFolder = url.startsWith(baseFolder) ? url : baseFolder + url;
  return baseUrl + pathWithFolder;
};
export {
  getAbsoluteUrl,
  getWixFilename,
  isAbsoluteUrl
};
//# sourceMappingURL=baseUrlConverter.js.map
